import { defaultTheme, type ThemeOverrides } from '@backend/lib-design-system';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

export interface CustomThemeOverrides extends ThemeOverrides {
  colors: ThemeOverrides['colors'] & { info: { normal: string } } & { secondary: { normal: string } } & {
    accent: { normal: string };
  };
  sizes: { maxBodyWidth: string };
}

export const palette = {
  darkBlue: '#272356',
  darkerBlue: '#201b3d',
  green: '#36CC75',
  darkGreen: '#28783A',
  darkerGreen: '#1E5A2C',
  darkestGreen: '#164321',
};

export const theme: CustomThemeOverrides = merge(cloneDeep(defaultTheme), {
  colors: {
    // on white, as text or behind white text: the brand green gives 2.1, WCAG asks 4.5 of body text (5.5 here)
    primary: {
      alpha: defaultTheme.palette.green400alpha,
      normal: palette.darkGreen,
      dark: palette.darkerGreen,
      darker: palette.darkestGreen,
    },
    // the brand green, on the dark navbar and hero only
    accent: {
      normal: palette.green,
    },
    secondary: {
      normal: palette.darkBlue,
    },
    // grey500, not grey400: 5.0 on white where grey400 gives 2.5
    info: {
      normal: defaultTheme.palette.grey500,
    },
    body: {
      text: palette.darkBlue,
    },
  },
  sizes: {
    maxBodyWidth: '1150px',
  },
  designTokens: {
    overlaySpaceToTarget: '0rem',
    cellTextSubSubColor: defaultTheme.palette.grey500,
  },
});

export const promanTheme: CustomThemeOverrides = merge(cloneDeep(theme), {
  colors: {
    primary: {
      alpha: 'rgba(64, 64, 180, 0.12)',
      normal: '#0F387C',
      dark: '#2A2A8C',
      darker: '#1D1D66',
    },
    accent: {
      normal: '#F58220',
    },
  },
});
